import BaseAPI, { querySuffix } from "./BaseAPI";
import { getAPIUrlV2 } from "../apiConfig";

export default class SensorAlertAPI extends BaseAPI {
    constructor(emitter) {
        super(emitter, "sensor-alert-settings", "sensor-alert");
    }
    settingsURL(id) {
        return id
            ? getAPIUrlV2(`temperature-locations/${encodeURIComponent(id)}/sensor-alert-settings`)
            : this._url();
    }
    async GetSettings(id = "") {
        return this._request("get", this.settingsURL(id));
    }
    async SaveSettings(id, data) {
        const saved = await this._request("put", this.settingsURL(id), data);
        this._emit("update", id);
        return saved;
    }
    async NotificationsPage(id, filters = {}) {
        const page = await this._request(
            "get",
            getAPIUrlV2(`issues/${id}/notifications`) + querySuffix(filters),
            null,
            { rawData: true }
        );
        return { data: page.data || [], next_page_token: page.next_page_token || "" };
    }
}
